import { useNavigate } from 'react-router-dom';
import { materialMeta } from '@/utils/content';

const dims = [
  {
    icon: 'ri-user-search-line',
    key: 'person',
    title: '按人物检索',
    desc: '同一当事人、机构或「导师」的多起事件自动聚合，看清话术是否重复、牵扯多深。',
  },
  {
    icon: 'ri-folder-chart-line',
    key: 'event',
    title: '按事件检索',
    desc: '围绕一件公共事件，把聊天、转账、录音、影像按发生顺序归拢，补档脉络一目了然。',
  },
  {
    icon: 'ri-time-line',
    key: 'time',
    title: '按时间检索',
    desc: '用时间线还原「先发了什么、后回应了什么」，避免只看单张截图就被带节奏。',
  },
];

export default function Browse() {
  const navigate = useNavigate();
  return (
    <section className="bg-background-100/60 border-y border-background-200/70">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
          <div>
            <p className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
              <span className="inline-block w-8 border-t-2 border-primary-500"></span>如何查找
            </p>
            <h2 className="mt-3 font-display font-black text-foreground-950 text-2xl md:text-3xl">
              三维检索，把散料拼成可核对的档案
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-sm md:text-right">
            单张截图最难判断真假。我们提供人物、事件、时间三种入口，方便你交叉比对完整上下文。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {dims.map((d) => (
            <button
              key={d.key}
              onClick={() => navigate(`/archive?q=${encodeURIComponent(d.title.replace('检索', ''))}`)}
              className="group text-left flex flex-col gap-3 bg-background-50 border border-background-200 rounded-lg p-5 md:p-6 hover:border-primary-300 hover:-translate-y-0.5 transition-all cursor-pointer"
            >
              <span className="inline-flex items-center justify-center w-11 h-11 rounded-lg bg-primary-100 text-primary-600 text-xl">
                <i className={d.icon}></i>
              </span>
              <div>
                <h3 className="font-display font-bold text-foreground-950 text-lg flex items-center gap-2">
                  {d.title}
                  <i className="ri-arrow-right-up-line text-primary-500 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                </h3>
                <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{d.desc}</p>
              </div>
            </button>
          ))}
        </div>

        <div className="mt-8 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
          <span className="text-sm text-foreground-500 whitespace-nowrap shrink-0">素材类型筛选</span>
          <div className="flex flex-wrap gap-2">
            {Object.entries(materialMeta).map(([k, v]) => (
              <button
                key={k}
                onClick={() => navigate(`/archive?type=${k}`)}
                className={`inline-flex items-center gap-1.5 text-sm px-3 py-1.5 rounded-full border border-transparent transition-colors cursor-pointer ${v.color}`}
              >
                <i className={v.icon}></i>
                {v.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}